export default function Clonable() {}